/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePreRegistrationDto } from '../../models/create-pre-registration-dto';
import { PreRegistrationDto } from '../../models/pre-registration-dto';

export interface PreRegistrationControllerCreateV1$Params {
      body: CreatePreRegistrationDto
}

export function preRegistrationControllerCreateV1(http: HttpClient, rootUrl: string, params: PreRegistrationControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PreRegistrationDto>> {
  const rb = new RequestBuilder(rootUrl, preRegistrationControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PreRegistrationDto>;
    })
  );
}

preRegistrationControllerCreateV1.PATH = '/api/v1/pre-registration';
